import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { ApiResourceService } from '../../apiResource/apiResource.service';
import { IAirSilentBookingRequest } from "libraries/service/resources/model/booking/air/IAirSilentBookingRequest";
import { IGetBookingsAirResponse } from '../booking/interfaces/IGetBookings';

const URL_AIR: string = 'air';
const URL_SILENT_BOOKING: string = 'silentBookings';

@Injectable()
export class AirSilentBookingResourceService {

    constructor(
        private readonly apiResourceService: ApiResourceService
    ) {
    }

    public postSilentBooking(body: IAirSilentBookingRequest, target: string): Observable<any> {
        return this.apiResourceService.postOne<IAirSilentBookingRequest, any>(
            this.apiResourceService.getApiUrl(URL_AIR, URL_SILENT_BOOKING),
            body, {}, { target }
        );
    }
}
